<script>

    import { onMount } from 'svelte'
    import { toast } from 'bulma-toast'
    import { stocksStore } from '../stores'

    import StocksService from '../$services/stocks.service'
    import Table from '../$components/table.svelte'

    let loading = false

    onMount(getStocksGroup)
    
    async function getStocksGroup() {
    
        loading = true
        const resp = await StocksService.getStocksGroup()
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        stocksStore.set(resp.data)
    }

</script>

<Table items={ $stocksStore.length } { loading } >
    <thead>
        <tr>
            <th>#</th>
            <th>Producto</th>
            <th>Sku</th>
            <th>Entradas</th>
            <th>Salidas</th>
            <th>Restante</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        {#each $stocksStore as stock, index}
            <tr>
                <td>{ index+1 }</td>
                <td>{ stock.merchandise.name }</td>
                <td>{ stock.merchandise.sku }</td>
                <td>{ stock.inputs }</td>
                <td>{ stock.outputs }</td>
                <td>{ stock.inputs - stock.outputs }</td>
                <td>
                    {#if stock.inputs - stock.outputs <= stock.merchandise.stockMin}
                        <span class="tag is-danger">Se requiere stock</span>
                    {/if}
                </td>
            </tr>
        {/each}
    </tbody>
</Table>